{
  "nav": {
    "mainNavigation": "التنقل الرئيسي",
    "sectionSettings": "الإعدادات",
    "settings": "الإعدادات",
    "tiers": "شرائح العمولة",
    "transferSettings": "إعدادات الحوالات",
    "users": "المستخدمين",
    "groups": "المجموعات",
    "transfers": "الحوالات",
    "boxes": "الصناديق",
    "bankAccounts": "الحسابات البنكية",
    "reports": "التقارير",
    "changeBranch": "تغيير الفرع",
    "systems": "الأنظمة",
    "toggleSidebarHint": "تبديل الشريط الجانبي",
    "newTransfer": "حوالة جديدة",
    "transferDrafts": "الحوالات المبدئية"
  },
  "sidebar": {
    "toggle": "تبديل الشريط الجانبي",
    "toggleHint": "إظهار أو إخفاء القائمة",
    "title": "القائمة الجانبية",
    "description": "التنقل بين صفحات النظام"
  },
  "brand": "المسافر"
}
